module.exports = __webpack_public_path__ + "assets/img/13_987_big.46e8cb97.jpg";